import { render, staticRenderFns } from "./settingperiode.vue?vue&type=template&id=72044e68&"
import script from "./settingperiode.vue?vue&type=script&lang=js&"
export * from "./settingperiode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports